import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import Reveal from "@/components/base/Reveal";
import { homeSteps } from "@/mocks/public";

export default function HowItWorksSection() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="container-page">
        <SectionHeading
          eyebrow="Comment ça marche"
          title="Opérationnel en quatre étapes"
          description="De la création du compte au suivi des loyers, la prise en main est rapide et progressive."
        />
        <div className="mt-12 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {homeSteps.map((step, index) => (
            <Reveal key={step.title} delay={index * 90} className="relative h-full">
              <div className="card-lift h-full rounded-lg border border-background-200 bg-background-100/60 p-5 hover:border-primary-300 hover:bg-background-50">
                <div className="flex items-center gap-3">
                  <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                    <i className={`${step.icon} text-xl`} aria-hidden="true" />
                  </span>
                  <span className="font-heading text-2xl font-semibold text-background-400">
                    {String(index + 1).padStart(2, "0")}
                  </span>
                </div>
                <h3 className="mt-4 text-base font-heading font-semibold text-foreground-950">{step.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{step.description}</p>
              </div>
            </Reveal>
          ))}
        </div>
        <div className="mt-10 flex justify-center">
          <Link
            to="/comment-ca-marche"
            className="link-arrow inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-foreground-200 bg-background-50 px-5 py-2.5 text-sm font-label font-medium text-foreground-900 hover:bg-background-100 hover:-translate-y-0.5 transition-all cursor-pointer"
          >
            Voir le parcours détaillé
            <i className="ri-arrow-right-line" aria-hidden="true" />
          </Link>
        </div>
      </div>
    </section>
  );
}